.badge {
  padding-inline: 8px;
  padding-top: 3px;
  padding-bottom: 4px;
  font-size: var(--font-size-xxs);
  color: var(--color-error-fill);
  border: 1px solid var(--color-error-fill);
  border-radius: 3px;
}
